// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2_2ze"};